import React from "react";
import Subscriptions from "../components/Subscriptions";
import Title from "../components/Title";
import './../assets/styles/main.scss';

const App = () => {
  return (
    <div className="App">
      <Title />
      <Subscriptions />
    </div>
  );
};

export default App;
